import { useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { Navbar2 } from "../../../Components/Navbar/Navbar";
import { useGeneralSettings } from "../../../Providers/General";
import { toast } from "react-toastify";
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;
const jwtTokenDeveloper = import.meta.env.VITE_JwtTokenDeveloper;

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [, setCookie] = useCookies();
  const [sentOTP, setsentOTP] = useState(false);
  const generalState = useGeneralSettings();
  const [otp, setOtp] = useState("");

  const handleSubmitOTP = async (e) => {
    e.preventDefault();
    generalState?.setLoading(true);
    const response = await fetch(
      `${host}/developer/sendMsg?message=DevLogin&subject=Anchors`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": "true",
        },
      }
    );
    const json = await response.json();
    if (json?.MessageID) {
      setsentOTP(true);
      generalState.setLoading(false);
      // let otpcode = parseInt(String(json?.code - 145626)) * 562002;
      // setCookie("ccoondfe", otpcode, { maxAge: 120 });
    } else {
      generalState.setLoading(false);
      console.log("Some error occurred", json);
    }
  };
  const CheckOTP = async (e) => {
    e.preventDefault();
    try {
      generalState.setLoading(true);
      const response = await fetch(`${host}/developer/verifyOtp`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": "true",
        },
        body: JSON.stringify({
          otp: otp,
        }),
      });
      const data = await response.json();
      if (data.success) {
        generalState.setLoading(false);
        toast.success("OTP Verified Successfully", { autoClose: 1500 });
        localStorage.setItem("jwtTokenD", jwtTokenDeveloper);
        localStorage.setItem("isDev", "true");
        setCookie("devsession", true, { maxAge: 30 * 24 * 60 * 60 * 1000 });
        navigate("/developer/admin");
      } else {
        generalState.setLoading(false);
        toast.error(data?.error, { autoClose: 1500 });
      }
    } catch (error) {
      generalState.setLoading(false);
      console.log(error);
      toast.error("Some error occurred", { autoClose: 1500 });
    }
  };
  const handleChange = (e) => {
    e.preventDefault();
    setOtp(e.target.value);
  };
  return (
    <>
      <Navbar2 />
      <div className="flex flex-col w-full h-full justify-center items-center">
        <span className="w-full text-center text-[#FAFAFA] text-[40px] font-[700] p-[30px] bg-[#670000]">
          Hello, Anchors | collab Builders <br />
          Let's work hard and raise the level of Anchors together.
        </span>
        <div className="w-full h-[65vh] bg-[#121212] flex flex-col items-center gap-[20px] justify-center">
          <button
            onClick={handleSubmitOTP}
            className="px-[20px] py-[12px] md:py-[16px] justify-center items-center gap-[10px] rounded-[8px] bg-[#FAFAFA] text-[16px] text-[#212121] font-[400]"
          >
            {sentOTP ? (
              <span className="text-[green] font-[600]">
                Otp sent successfully
              </span>
            ) : (
              "Login with OTP"
            )}
          </button>
          {sentOTP && (
            <div className="mx-auto block max-w-sm rounded-lg bg-white p-6 shadow-4 dark:bg-surface-dark">
              <form>
                {/* <!--Password input--> */}
                <div className="relative mb-6" data-twe-input-wrapper-init>
                  <input
                    type=""
                    className="peer block min-h-[auto] w-full rounded border-0 bg-transparent px-3 py-[0.32rem] leading-[1.6] outline transition-all duration-200 ease-linear focus:placeholder:opacity-100 peer-focus:text-primary data-[twe-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none dark:text-white dark:placeholder:text-neutral-300 dark:autofill:shadow-autofill dark:peer-focus:text-primary [&:not([data-twe-input-placeholder-active])]:placeholder:opacity-0"
                    id="exampleInputPassword2"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={handleChange}
                  />
                  <label className="pointer-events-none absolute left-3 top-0 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[twe-input-state-active]:-translate-y-[0.9rem] peer-data-[twe-input-state-active]:scale-[0.8] motion-reduce:transition-none dark:text-neutral-300 dark:peer-focus:text-primary">
                    OTP
                  </label>
                </div>

                {/* <!--Sign in button--> */}
                <button
                  onClick={CheckOTP}
                  type="submit"
                  className="inline-block w-full rounded bg-red-400 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-primary-3 transition duration-150 ease-in-out hover:bg-primary-accent-300 hover:shadow-primary-2 focus:bg-primary-accent-300 focus:shadow-primary-2 focus:outline-none focus:ring-0 active:bg-primary-600 active:shadow-primary-2 dark:shadow-black/30 dark:hover:shadow-dark-strong dark:focus:shadow-dark-strong dark:active:shadow-dark-strong"
                  data-twe-ripple-init
                  data-twe-ripple-color="light"
                >
                  Sign in
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
